var _style, _defs, _path, _defs2, _rect, _defs3, _rect2, _defs4, _rect3, _defs5, _rect4, _defs6, _rect5, _defs7, _rect6, _defs8, _rect7, _defs9, _rect8, _defs10, _rect9, _defs11, _rect10, _defs12, _rect11, _defs13, _rect12, _defs14, _rect13, _defs15, _rect14, _defs16, _rect15, _defs17, _rect16, _defs18, _rect17, _defs19, _rect18, _defs20, _rect19, _defs21, _rect20, _defs22, _rect21, _defs23, _rect22, _defs24, _rect23, _defs25, _rect24, _defs26, _rect25, _defs27, _rect26, _defs28, _rect27, _defs29, _rect28, _defs30, _rect29, _defs31, _rect30, _defs32, _rect31, _defs33, _rect32, _defs34, _rect33, _defs35, _rect34, _defs36, _rect35, _defs37, _rect36, _defs38, _rect37, _defs39, _rect38, _defs40, _rect39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDinerClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 156 128"
    },
    viewBox: "0 0 156 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:#FFFFFF;stroke:#CBCBCB;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{clip-path:url(#SVGID_4_);fill:#1A1919;}\n\t.st2{clip-path:url(#SVGID_6_);fill:#1A1919;}\n\t.st3{clip-path:url(#SVGID_8_);fill:#1A1919;}\n\t.st4{clip-path:url(#SVGID_10_);fill:#1A1919;}\n\t.st5{clip-path:url(#SVGID_12_);fill:#1A1919;}\n\t.st6{clip-path:url(#SVGID_14_);fill:#1A1919;}\n\t.st7{clip-path:url(#SVGID_16_);fill:#1A1919;}\n\t.st8{clip-path:url(#SVGID_18_);fill:#1A1919;}\n\t.st9{clip-path:url(#SVGID_20_);fill:#1A1919;}\n\t.st10{clip-path:url(#SVGID_22_);fill:#1A1919;}\n\t.st11{clip-path:url(#SVGID_24_);fill:#1A1919;}\n\t.st12{clip-path:url(#SVGID_26_);fill:#1A1919;}\n\t.st13{clip-path:url(#SVGID_28_);fill:#1A1919;}\n\t.st14{clip-path:url(#SVGID_30_);fill:#1A1919;}\n\t.st15{clip-path:url(#SVGID_32_);fill:#1A1919;}\n\t.st16{clip-path:url(#SVGID_34_);fill:#1A1919;}\n\t.st17{clip-path:url(#SVGID_36_);fill:#1A1919;}\n\t.st18{clip-path:url(#SVGID_38_);fill:#1A1919;}\n\t.st19{clip-path:url(#SVGID_40_);fill:#1A1919;}\n\t.st20{clip-path:url(#SVGID_42_);fill:#1A1919;}\n\t.st21{clip-path:url(#SVGID_44_);fill:#1A1919;}\n\t.st22{clip-path:url(#SVGID_46_);fill:#1A1919;}\n\t.st23{clip-path:url(#SVGID_48_);fill:#1A1919;}\n\t.st24{clip-path:url(#SVGID_50_);fill:#1A1919;}\n\t.st25{clip-path:url(#SVGID_52_);fill:#1A1919;}\n\t.st26{clip-path:url(#SVGID_54_);fill:#1A1919;}\n\t.st27{clip-path:url(#SVGID_56_);fill:#1A1919;}\n\t.st28{clip-path:url(#SVGID_58_);fill:#1A1919;}\n\t.st29{clip-path:url(#SVGID_60_);fill:#1A1919;}\n\t.st30{clip-path:url(#SVGID_62_);fill:#1A1919;}\n\t.st31{clip-path:url(#SVGID_64_);fill:#1A1919;}\n\t.st32{clip-path:url(#SVGID_66_);fill:#1A1919;}\n\t.st33{clip-path:url(#SVGID_68_);fill:#1A1919;}\n\t.st34{clip-path:url(#SVGID_70_);fill:#1A1919;}\n\t.st35{clip-path:url(#SVGID_72_);fill:#1A1919;}\n\t.st36{clip-path:url(#SVGID_74_);fill:#1A1919;}\n\t.st37{clip-path:url(#SVGID_76_);fill:#1A1919;}\n\t.st38{clip-path:url(#SVGID_78_);fill:#FFFFFE;}\n\t.st39{clip-path:url(#SVGID_80_);fill:#184977;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14,30c0-3.3,2.7-6,6-6h116c3.3,0,6,2.7,6,6v68c0,3.3-2.7,6-6,6H20c-3.3,0-6-2.7-6-6V30z",
    id: "SVGID_1_"
  }))), /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    xlinkHref: "#SVGID_1_"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_1_"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,30c0-3.3,2.7-6,6-6h116c3.3,0,6,2.7,6,6v68c0,3.3-2.7,6-6,6H20c-3.3,0-6-2.7-6-6V30z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.9,79.8c0,1.4,1,1.5,1.8,1.5c3.8,0,5.1-2.9,5.1-5.5c0-3.3-2.1-5.7-5.5-5.7c-0.7,0-1.1,0.1-1.4,0.1V79.8z     M38.1,71.5c0-1.6-0.8-1.5-1.6-1.5v-0.5c0.7,0,1.4,0,2.1,0c0.7,0,1.7,0,3.1,0c4.6,0,7.1,3.1,7.1,6.2c0,1.7-1,6.1-7.3,6.1    c-0.9,0-1.7,0-2.6,0c-0.8,0-1.6,0-2.4,0v-0.5c1.1-0.1,1.6-0.1,1.6-1.3V71.5z",
    id: "SVGID_3_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_3_"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 22.3,
    width: 22.2,
    x: 31.5,
    y: 64.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.2,71.1c-0.5,0-0.9-0.4-0.9-0.9c0-0.4,0.4-0.8,0.9-0.8c0.5,0,0.9,0.4,0.9,0.8    C52.1,70.7,51.7,71.1,51.2,71.1z M49.3,81.4h0.3c0.5,0,0.8,0,0.8-0.6V76c0-0.8-0.3-0.9-0.9-1.2v-0.3c0.8-0.2,1.8-0.6,1.9-0.6    c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.1,0.1,0.1,0.2v6.8c0,0.6,0.4,0.6,0.9,0.6h0.3v0.5c-0.6,0-1.2,0-1.9,0c-0.6,0-1.3,0-1.9,0V81.4z",
    id: "SVGID_5_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_5_"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 22.5,
    width: 13.8,
    x: 44.3,
    y: 64.3
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.8,76.1c0-0.7-0.2-0.8-1-1.2v-0.3c0.8-0.2,1.5-0.5,2.3-0.8c0.1,0,0.1,0,0.1,0.2v1.1    c1-0.7,1.9-1.3,3.1-1.3c1.5,0,2,1.1,2,2.5v4.6c0,0.6,0.4,0.6,0.9,0.6h0.3v0.5c-0.6,0-1.2,0-1.9,0c-0.6,0-1.3,0-1.9,0v-0.5H59    c0.5,0,0.8,0,0.8-0.6v-4.6c0-1-0.6-1.5-1.6-1.5c-0.6,0-1.5,0.5-2.1,0.8v5.2c0,0.6,0.4,0.6,0.9,0.6h0.3v0.5c-0.6,0-1.2,0-1.9,0    c-0.6,0-1.3,0-1.9,0v-0.5h0.3c0.5,0,0.8,0,0.8-0.6V76.1",
    id: "SVGID_7_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_7_"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    height: 18.1,
    width: 18.9,
    x: 48.6,
    y: 68.8
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M67,76.4c0.4,0,0.5-0.2,0.5-0.4c0-0.9-0.5-1.6-1.5-1.6c-1.1,0-1.8,0.8-2,2.1H67z M63.8,77c0,0.2,0,0.4,0,1    c0.1,1.7,1.2,3.1,2.6,3.1c1,0,1.7-0.5,2.4-1.2l0.2,0.2c-0.8,1.1-1.8,2-3.3,2c-2.8,0-3.4-2.7-3.4-3.8c0-3.5,2.3-4.5,3.6-4.5    c1.4,0,3,0.9,3,2.8c0,0.1,0,0.2,0,0.3L68.8,77H63.8z",
    id: "SVGID_9_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_9_"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    height: 18.3,
    width: 16.6,
    x: 57.4,
    y: 68.8
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M69.4,81.4h0.5c0.5,0,0.8,0,0.8-0.6v-5c0-0.5-0.7-0.7-0.9-0.8v-0.3c1.3-0.5,2-1,2.2-1    c0.1,0,0.2,0.1,0.2,0.2v1.6h0c0.4-0.7,1.2-1.8,2.3-1.8c0.4,0,1,0.3,1,0.9c0,0.5-0.3,0.9-0.8,0.9c-0.5,0-0.5-0.4-1.2-0.4    c-0.3,0-1.3,0.4-1.3,1.5v4.1c0,0.6,0.4,0.6,0.8,0.6h1v0.5c-1,0-1.7,0-2.5,0c-0.7,0-1.5,0-2.1,0V81.4",
    id: "SVGID_11_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_11_"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    height: 18.1,
    width: 16,
    x: 64.4,
    y: 68.8
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.2,79.4c0.2,1.2,0.9,2.2,2.2,2.2c1,0,1.4-0.6,1.4-1.3c0-2.1-3.8-1.4-3.8-4.3c0-1,0.8-2.3,2.7-2.3    c0.6,0,1.3,0.2,2,0.5l0.1,1.8h-0.4c-0.2-1.1-0.8-1.7-1.9-1.7c-0.7,0-1.4,0.4-1.4,1.2c0,2.1,4.1,1.4,4.1,4.2c0,1.2-0.9,2.4-3,2.4    c-0.7,0-1.5-0.2-2.2-0.6l-0.2-2L76.2,79.4",
    id: "SVGID_13_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_13_"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 18.3,
    width: 15.4,
    x: 70.8,
    y: 68.8
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M97.2,72.7h-0.4c-0.3-2.1-1.8-2.9-3.8-2.9c-2,0-5,1.4-5,5.6c0,3.6,2.5,6.1,5.3,6.1c1.7,0,3.2-1.2,3.5-3.1    l0.4,0.1l-0.4,2.6c-0.7,0.5-2.7,0.9-3.9,0.9c-4.1,0-6.7-2.7-6.7-6.6c0-3.6,3.2-6.2,6.7-6.2c1.4,0,2.8,0.5,4.2,0.9L97.2,72.7",
    id: "SVGID_15_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_15_"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "st7",
    height: 22.9,
    width: 21.1,
    x: 81.1,
    y: 64.3
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M97.8,81.4h0.3c0.5,0,0.8,0,0.8-0.6V71c0-1.1-0.3-1.2-0.9-1.4v-0.3c0.7-0.2,1.4-0.5,1.8-0.8    c0.2-0.1,0.3-0.2,0.4-0.2c0.1,0,0.1,0.1,0.1,0.2v12.2c0,0.6,0.4,0.6,0.9,0.6h0.3v0.5c-0.6,0-1.2,0-1.9,0c-0.6,0-1.3,0-1.9,0V81.4",
    id: "SVGID_17_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_17_"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    height: 23.5,
    width: 13.8,
    x: 92.8,
    y: 63.4
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M109.1,80.9c0,0.3,0.2,0.3,0.5,0.3c0.2,0,0.5,0,0.7,0v0.4c-0.8,0.1-2.2,0.4-2.5,0.5l-0.1-0.1v-1.4    c-1.1,0.9-1.9,1.5-3.1,1.5c-1,0-1.9-0.6-1.9-2.1v-4.5c0-0.5-0.1-0.9-1.1-1v-0.3c0.6,0,2-0.1,2.3-0.1c0.2,0,0.2,0.1,0.2,0.5v4.6    c0,0.5,0,2,1.5,2c0.6,0,1.4-0.5,2.1-1.1v-4.8c0-0.4-0.8-0.5-1.5-0.7v-0.3c1.6-0.1,2.6-0.2,2.8-0.2c0.1,0,0.1,0.1,0.1,0.3V80.9",
    id: "SVGID_19_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_19_"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    height: 18.1,
    width: 18.8,
    x: 96.6,
    y: 69
  }))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.7,79.9c0,0.7,0.6,1.8,1.8,1.8c1.9,0,2.7-1.9,2.7-3.4c0-1.9-1.4-3.5-2.8-3.5c-0.7,0-1.2,0.4-1.7,0.8    V79.9z M112.7,75.1c0.7-0.6,1.7-1.3,2.6-1.3c2,0,3.3,1.8,3.3,3.7c0,2.3-1.7,4.6-4.2,4.6c-1.3,0-2-0.4-2.5-0.6l-0.5,0.4l-0.4-0.2    c0.2-1,0.2-2.1,0.2-3.1V71c0-1.1-0.3-1.2-0.9-1.4v-0.3c0.7-0.2,1.4-0.5,1.8-0.8c0.2-0.1,0.3-0.2,0.4-0.2c0.1,0,0.1,0.1,0.1,0.2    V75.1z",
    id: "SVGID_21_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_21_"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    height: 23.8,
    width: 18.3,
    x: 105.3,
    y: 63.4
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.5,92.1h0.1c0.3,0,0.7,0,0.7-0.5v-5c0-0.5-0.4-0.5-0.7-0.5h-0.1v-0.3c0.4,0,1,0,1.4,0    c0.5,0,1.1,0,1.5,0V86h-0.1c-0.3,0-0.7,0-0.7,0.5v5c0,0.5,0.4,0.5,0.7,0.5h0.1v0.3c-0.5,0-1,0-1.5,0c-0.5,0-1,0-1.4,0V92.1",
    id: "SVGID_23_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_23_"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    height: 16.7,
    width: 12.9,
    x: 31.5,
    y: 80.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.4,92.4l0-0.2h-0.1c-0.3,0-0.8-0.1-0.8-0.6v-5c0-0.5,0.4-0.6,0.8-0.6h0.1v-0.2c-0.4,0-1,0-1.5,0    c-0.5,0-1,0-1.4,0v0.2h0.1c0.3,0,0.8,0.1,0.8,0.6v5c0,0.5-0.4,0.6-0.8,0.6h-0.1v0.2c0.4,0,0.9,0,1.4,0    C38.4,92.3,38.9,92.4,39.4,92.4z M39.4,92.4c-0.5,0-1,0-1.5,0c-0.5,0-1,0-1.4,0h0v-0.4h0.2c0.3,0,0.7,0,0.7-0.5v-5    c0-0.5-0.3-0.5-0.7-0.5h-0.2v-0.4h0c0.4,0,1,0,1.4,0c0.5,0,1.1,0,1.5,0h0V86h-0.2c-0.3,0-0.7,0-0.7,0.5v5c0,0.5,0.3,0.5,0.7,0.5    h0.2L39.4,92.4L39.4,92.4z",
    id: "SVGID_25_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_25_"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    height: 16.8,
    width: 13,
    x: 31.5,
    y: 80.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M46,90.5L46,90.5l0-3.6c0-0.8-0.5-0.9-0.8-0.9H45v-0.3c0.5,0,0.9,0,1.3,0c0.4,0,0.8,0,1.2,0V86h-0.1    c-0.4,0-0.9,0.1-0.9,1.2v4.4c0,0.3,0,0.7,0.1,1h-0.4L41.3,87v4c0,0.8,0.2,1.1,0.9,1.1h0.2v0.3c-0.4,0-0.8,0-1.2,0    c-0.4,0-0.9,0-1.3,0v-0.3h0.1c0.7,0,0.9-0.5,0.9-1.2v-4c0-0.5-0.4-0.9-0.9-0.9h-0.1v-0.3c0.4,0,0.7,0,1.1,0c0.3,0,0.6,0,0.9,0    L46,90.5",
    id: "SVGID_27_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_27_"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    height: 16.9,
    width: 17.7,
    x: 34.8,
    y: 80.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M46,90.5L46,90.5L46,90.5L46,90.5z M46,90.5L46,90.5L46,90.5z M46.2,92.5h0.3c0-0.3-0.1-0.6-0.1-0.9v-4.4    c0-1.2,0.5-1.3,0.9-1.3h0.1v-0.2c-0.4,0-0.8,0-1.1,0c-0.4,0-0.9,0-1.3,0l0,0.2h0.2c0.3,0,0.9,0.1,0.9,0.9l0,3.6l0,0l0,0l-4.3-4.8    c-0.3,0-0.6,0-0.9,0c-0.4,0-0.7,0-1.1,0l0,0.2h0.1c0.5,0,0.9,0.3,0.9,0.9v4c0,0.8-0.2,1.3-0.9,1.3l-0.1,0v0.2c0.4,0,0.8,0,1.3,0    c0.4,0,0.8,0,1.2,0v-0.2h-0.1c-0.8,0-0.9-0.3-0.9-1.2v-4.1L46.2,92.5z M46.6,92.6l-0.4,0l-4.9-5.4V91c0,0.8,0.1,1.1,0.9,1.1h0.2    v0.4h0c-0.4,0-0.8,0-1.2,0c-0.4,0-0.9,0-1.3,0h0v-0.4h0.2c0.6,0,0.8-0.4,0.8-1.2v-4c0-0.5-0.4-0.8-0.8-0.8h-0.2v-0.4h0    c0.4,0,0.7,0,1.1,0c0.3,0,0.6,0,0.9,0l4.2,4.8v-3.5c0-0.8-0.5-0.9-0.8-0.9H45v-0.4h0c0.5,0,0.9,0,1.3,0c0.4,0,0.8,0,1.2,0h0V86    h-0.2c-0.4,0-0.8,0-0.8,1.2v4.4C46.6,91.9,46.6,92.3,46.6,92.6L46.6,92.6L46.6,92.6z",
    id: "SVGID_29_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_29_"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "st14",
    height: 16.9,
    width: 17.8,
    x: 34.7,
    y: 80.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M49,86.2c-0.7,0-0.7,0.2-0.9,0.9h-0.3c0-0.3,0.1-0.5,0.1-0.8c0-0.3,0.1-0.5,0.1-0.8h0.2    c0.1,0.3,0.3,0.3,0.6,0.3h5c0.3,0,0.5,0,0.5-0.3l0.2,0c0,0.3-0.1,0.5-0.1,0.8c0,0.3,0,0.5,0,0.8l-0.3,0.1c0-0.4-0.1-0.9-0.7-0.9    h-1.6v5.1c0,0.7,0.3,0.8,0.8,0.8h0.2v0.3c-0.4,0-1,0-1.6,0c-0.6,0-1.3,0-1.6,0v-0.3h0.2c0.5,0,0.8,0,0.8-0.8v-5.1H49",
    id: "SVGID_31_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_31_"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "st15",
    height: 17,
    width: 16.7,
    x: 42.8,
    y: 80.4
  }))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.7,92.4c-0.4,0-1.1,0-1.6,0c-0.6,0-1.2,0-1.6,0h0v-0.4h0.2c0.5,0,0.7,0,0.8-0.8v-5.1H49v-0.1h1.6v5.2    c0,0.8-0.3,0.8-0.8,0.8h-0.1v0.2c0.4,0,1,0,1.6,0C51.7,92.3,52.3,92.4,52.7,92.4l0-0.3h-0.1c-0.5,0-0.8-0.1-0.8-0.9v-5.2h1.6    c0.6,0,0.7,0.6,0.7,0.9l0.2-0.1c0-0.3,0-0.5,0-0.8c0-0.2,0.1-0.5,0.1-0.7l-0.1,0c0,0.3-0.3,0.3-0.6,0.3h-5c-0.2,0-0.5,0-0.6-0.3    H48c0,0.3,0,0.5-0.1,0.8c0,0.3-0.1,0.5-0.1,0.8H48c0.1-0.7,0.2-0.9,0.9-0.9v0.1c-0.7,0-0.7,0.1-0.9,0.8l0,0h-0.4l0,0    c0-0.3,0.1-0.5,0.1-0.8c0-0.3,0.1-0.5,0.1-0.8v0h0.3l0,0c0.1,0.2,0.2,0.2,0.5,0.2h5c0.3,0,0.5,0,0.5-0.3l0,0l0,0l0.3,0l0,0    c0,0.3-0.1,0.5-0.1,0.8c0,0.3,0,0.5,0,0.8v0l0,0L54,87.2l0-0.1c0-0.4-0.1-0.9-0.7-0.9h-1.5v5.1c0,0.7,0.3,0.8,0.8,0.8h0.2    L52.7,92.4L52.7,92.4",
    id: "SVGID_33_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_33_"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "st16",
    height: 17.1,
    width: 16.8,
    x: 42.7,
    y: 80.4
  }))), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.8,92.1h0.1c0.3,0,0.7,0,0.7-0.5v-5c0-0.5-0.4-0.5-0.7-0.5h-0.1v-0.3c0.6,0,1.6,0,2.4,0    c0.8,0,1.8,0,2.5,0c0,0.4,0,1,0,1.5l-0.3,0.1c0-0.6-0.2-1.1-1.2-1.1h-1.3v2.5H58c0.6,0,0.7-0.3,0.8-0.8H59c0,0.4,0,0.7,0,1.1    c0,0.4,0,0.7,0,1.1l-0.3,0.1c-0.1-0.6-0.1-1-0.7-1h-1.2v2.2c0,0.6,0.6,0.6,1.2,0.6c1.2,0,1.7-0.1,2-1.2l0.3,0.1    c-0.1,0.5-0.2,1-0.3,1.5c-0.6,0-1.7,0-2.6,0c-0.9,0-2,0-2.6,0V92.1",
    id: "SVGID_35_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_35_"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "st17",
    height: 16.7,
    width: 15.5,
    x: 49.8,
    y: 80.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.9,92.4c0.1-0.5,0.2-1,0.3-1.5l-0.2,0c-0.3,1.1-0.8,1.2-2,1.2c-0.6,0-1.2,0-1.2-0.7v-2.3H58    c0.7,0,0.7,0.4,0.8,0.9l0.2,0c0-0.4,0-0.7,0-1.1c0-0.4,0-0.7,0-1.1h-0.2c-0.1,0.5-0.2,0.9-0.8,0.8h-1.2v-2.6h1.4    c1,0,1.2,0.5,1.2,1.1l0.2-0.1c0-0.3,0-0.6,0-0.9c0-0.2,0-0.3,0-0.5c-0.7,0-1.6,0-2.4,0c-0.8,0-1.8,0-2.3,0v0.2h0.1    c0.3,0,0.8,0.1,0.8,0.6v5c0,0.5-0.4,0.6-0.8,0.6h-0.1v0.2c0.6,0,1.7,0,2.5,0C58.2,92.3,59.3,92.4,59.9,92.4z M59.9,92.4    c-0.6,0-1.7,0-2.6,0c-0.9,0-2,0-2.6,0h0v-0.4h0.2c0.3,0,0.7,0,0.7-0.5v-5c0-0.5-0.3-0.5-0.7-0.5h-0.2v-0.4h0c0.6,0,1.6,0,2.4,0    c0.8,0,1.8,0,2.5,0h0l0,0c0,0.1,0,0.3,0,0.5c0,0.3,0,0.7,0,1l0,0l0,0l-0.3,0.1l0,0c-0.1-0.6-0.1-1.1-1.1-1.1h-1.3l0,2.4H58    c0.6,0,0.7-0.3,0.7-0.8l0,0h0.4l0,0c0,0.4,0,0.7,0,1.1c0,0.4,0,0.7,0,1.1l0,0l0,0l-0.3,0.1l0,0c-0.1-0.6-0.1-0.9-0.7-0.9h-1.1v2.2    c0,0.6,0.5,0.6,1.1,0.6c1.2,0,1.6-0.1,1.9-1.1l0,0l0,0l0.3,0.1l0,0C60.2,91.4,60,91.9,59.9,92.4L59.9,92.4L59.9,92.4z",
    id: "SVGID_37_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_37_"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    height: 16.8,
    width: 15.6,
    x: 49.7,
    y: 80.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.8,88.9h0.5c1,0,1.5-0.4,1.5-1.5c0-0.9-0.5-1.4-1.4-1.4c-0.3,0-0.4,0-0.5,0V88.9z M61.5,86.7    c0-0.7-0.4-0.7-0.7-0.7h-0.2v-0.3c0.3,0,0.9,0,1.5,0c0.6,0,1,0,1.5,0c1.2,0,2.3,0.3,2.3,1.7c0,0.9-0.6,1.4-1.3,1.7l1.6,2.5    c0.3,0.4,0.5,0.5,0.9,0.6v0.3c-0.3,0-0.6,0-0.9,0c-0.3,0-0.6,0-0.9,0c-0.7-1-1.4-2-2-3.1h-0.6v2.1c0,0.7,0.3,0.8,0.8,0.8h0.2v0.3    c-0.5,0-1.1,0-1.7,0c-0.5,0-0.9,0-1.4,0v-0.3h0.2c0.4,0,0.7-0.2,0.7-0.5V86.7z",
    id: "SVGID_39_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_39_"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "st19",
    height: 16.7,
    width: 16.6,
    x: 55.7,
    y: 80.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.2,88.9c1,0,1.4-0.3,1.4-1.5c0-0.8-0.5-1.4-1.4-1.4c-0.3,0-0.4,0-0.5,0v2.8H63.2z M62.8,89L62.8,89    l0-2.9l0,0c0.1,0,0.3,0,0.6,0c0.9,0,1.4,0.6,1.4,1.4c0,1.1-0.6,1.5-1.5,1.5H62.8z M62.8,89.3h0.7l0,0c0.6,1.1,1.3,2.1,2,3.1    c0.3,0,0.6,0,0.9,0c0.3,0,0.6,0,0.9,0v-0.2c-0.5-0.1-0.7-0.2-0.9-0.6l-1.7-2.5l0,0c0.8-0.3,1.3-0.8,1.3-1.7c0-1.3-1-1.6-2.2-1.6    c-0.5,0-1,0-1.5,0c-0.6,0-1.1,0-1.4,0v0.2h0.1c0.3,0,0.7,0.1,0.7,0.8v4.9c0,0.4-0.4,0.6-0.7,0.6h-0.1v0.2c0.5,0,0.9,0,1.4,0    c0.5,0,1.1,0,1.6,0v-0.2h-0.1c-0.4,0-0.8-0.1-0.8-0.8L62.8,89.3L62.8,89.3z M67.2,92.4c-0.3,0-0.6,0-0.9,0c-0.3,0-0.6,0-0.9,0    c-0.7-1-1.4-2-2-3.1h-0.6v2c0,0.7,0.3,0.7,0.7,0.7h0.2v0.4h0c-0.5,0-1.1,0-1.7,0c-0.5,0-0.9,0-1.4,0h0v-0.4h0.2    c0.3,0,0.6-0.2,0.6-0.5v-4.9c0-0.7-0.3-0.7-0.6-0.7h-0.2v-0.4h0c0.3,0,0.9,0,1.5,0c0.6,0,1,0,1.5,0c1.2,0,2.3,0.3,2.3,1.7    c0,0.9-0.6,1.4-1.3,1.7l1.6,2.4c0.3,0.4,0.4,0.5,0.9,0.6l0,0L67.2,92.4L67.2,92.4z",
    id: "SVGID_41_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_41_"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    height: 16.8,
    width: 16.6,
    x: 55.6,
    y: 80.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.8,90.5L73.8,90.5l0-3.6c0-0.8-0.5-0.9-0.8-0.9h-0.2v-0.3c0.5,0,0.9,0,1.3,0c0.4,0,0.8,0,1.2,0V86h-0.1    c-0.4,0-0.9,0.1-0.9,1.2v4.4c0,0.3,0,0.7,0.1,1H74L69,87v4c0,0.8,0.2,1.1,0.9,1.1h0.2v0.3c-0.4,0-0.8,0-1.2,0c-0.4,0-0.9,0-1.3,0    v-0.3h0.1c0.7,0,0.9-0.5,0.9-1.2v-4c0-0.5-0.4-0.9-0.9-0.9h-0.1v-0.3c0.4,0,0.7,0,1.1,0c0.3,0,0.6,0,0.9,0L73.8,90.5",
    id: "SVGID_43_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_43_"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "st21",
    height: 16.9,
    width: 17.7,
    x: 62.5,
    y: 80.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.7,90.5L73.7,90.5L73.7,90.5L73.7,90.5z M73.8,90.5L73.8,90.5L73.8,90.5z M74,92.5h0.3    c0-0.3-0.1-0.6-0.1-0.9v-4.4c0-1.2,0.5-1.3,0.9-1.3h0.1v-0.2c-0.4,0-0.8,0-1.1,0c-0.4,0-0.9,0-1.3,0v0.2h0.2    c0.3,0,0.9,0.1,0.9,0.9l0,3.6l0,0l0,0l-4.3-4.8c-0.3,0-0.6,0-0.9,0c-0.4,0-0.7,0-1.1,0v0.2h0.1c0.5,0,0.9,0.3,0.9,0.9v4    c0,0.8-0.2,1.3-0.9,1.3l-0.1,0v0.2c0.4,0,0.8,0,1.3,0c0.4,0,0.8,0,1.2,0v-0.2h-0.1c-0.8,0-0.9-0.3-0.9-1.2v-4.1L74,92.5z     M74.3,92.6l-0.4,0L69,87.1V91c0,0.8,0.1,1.1,0.9,1.1h0.2v0.4h0c-0.4,0-0.8,0-1.2,0c-0.4,0-0.9,0-1.3,0h0v-0.4h0.2    c0.6,0,0.8-0.4,0.8-1.2v-4c0-0.5-0.4-0.8-0.8-0.8h-0.2v-0.4h0c0.4,0,0.7,0,1.1,0c0.3,0,0.6,0,0.9,0l4.2,4.8v-3.5    c0-0.8-0.5-0.9-0.8-0.9h-0.3v-0.4h0c0.5,0,0.9,0,1.3,0c0.4,0,0.8,0,1.2,0h0V86h-0.2c-0.4,0-0.8,0-0.8,1.2v4.4    C74.3,91.9,74.3,92.2,74.3,92.6L74.3,92.6L74.3,92.6z",
    id: "SVGID_45_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_45_"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "st22",
    height: 16.9,
    width: 17.8,
    x: 62.5,
    y: 80.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.2,86.8L78.2,86.8l-0.9,2.7h1.8L78.2,86.8z M76.8,91c-0.1,0.3-0.2,0.6-0.2,0.7c0,0.3,0.4,0.3,0.7,0.3    h0.1v0.3c-0.4,0-0.8,0-1.2,0c-0.3,0-0.7,0-1,0v-0.3h0.1c0.4,0,0.7-0.2,0.8-0.6l1.5-4.4c0.1-0.4,0.3-0.8,0.4-1.2    c0.3-0.1,0.7-0.3,0.9-0.4c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0.1,0.1,0.2,0.1,0.2l1.8,5c0.1,0.3,0.2,0.7,0.4,1    c0.1,0.3,0.3,0.4,0.6,0.4h0.1v0.3c-0.4,0-0.9,0-1.3,0c-0.5,0-1,0-1.4,0v-0.3h0.1c0.2,0,0.6,0,0.6-0.3c0-0.1-0.1-0.4-0.2-0.7    L79.3,90h-2.2L76.8,91z",
    id: "SVGID_47_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_47_"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "st23",
    height: 16.9,
    width: 16.7,
    x: 70.2,
    y: 80.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.2,86.8L78.2,86.8L78.2,86.8z M77.4,89.5H79l-0.8-2.6L77.4,89.5z M77.2,89.5l0.9-2.8h0.1v0l0,0l0,0v0h0    l0.9,2.8H77.2z M79.2,92.4c0.5,0,0.9,0,1.4,0c0.4,0,0.9,0,1.3,0v-0.2h0c-0.3,0-0.6-0.1-0.7-0.4c-0.1-0.3-0.2-0.6-0.4-1l-1.8-5    c0-0.1-0.1-0.2-0.1-0.2c0,0,0,0,0,0h0c0,0,0,0-0.1,0c-0.2,0.1-0.6,0.3-0.9,0.4c-0.1,0.4-0.2,0.8-0.4,1.2l-1.5,4.4    c-0.1,0.4-0.5,0.7-0.9,0.7h0v0.2c0.3,0,0.7,0,1,0c0.4,0,0.8,0,1.1,0v-0.2h-0.1c-0.3,0-0.8,0-0.8-0.4c0-0.2,0.1-0.4,0.2-0.8l0,0    l0,0l0.3-1h2.2l0.4,1.1c0.1,0.3,0.2,0.6,0.2,0.7c0,0.3-0.4,0.3-0.6,0.3h-0.1V92.4z M81.9,92.4c-0.4,0-0.9,0-1.3,0    c-0.5,0-1,0-1.4,0l0,0v-0.4h0.1c0.2,0,0.6,0,0.6-0.2c0-0.1-0.1-0.4-0.2-0.7l-0.4-1.1h-2.1l-0.3,1c-0.1,0.3-0.2,0.6-0.2,0.7    c0,0.2,0.4,0.3,0.7,0.3h0.1v0.4l0,0c-0.4,0-0.8,0-1.2,0c-0.3,0-0.7,0-1,0l0,0v-0.4h0.1c0.4,0,0.7-0.2,0.8-0.6l1.5-4.4    c0.1-0.4,0.3-0.8,0.4-1.2c0.3-0.1,0.7-0.3,0.9-0.4c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0.1,0.1,0.2,0.1,0.2l1.8,5    c0.1,0.3,0.2,0.7,0.4,1c0.1,0.3,0.3,0.4,0.6,0.4H82L81.9,92.4L81.9,92.4z",
    id: "SVGID_49_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_49_"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    height: 17,
    width: 16.8,
    x: 70.2,
    y: 80.4
  }))), /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.3,86.2c-0.7,0-0.7,0.2-0.9,0.9h-0.3c0-0.3,0.1-0.5,0.1-0.8c0-0.3,0.1-0.5,0.1-0.8h0.2    c0.1,0.3,0.3,0.3,0.6,0.3h5c0.3,0,0.5,0,0.5-0.3l0.2,0c0,0.3-0.1,0.5-0.1,0.8c0,0.3,0,0.5,0,0.8l-0.3,0.1c0-0.4-0.1-0.9-0.7-0.9    h-1.6v5.1c0,0.7,0.3,0.8,0.8,0.8h0.2v0.3c-0.4,0-1,0-1.6,0c-0.6,0-1.2,0-1.6,0v-0.3h0.2c0.5,0,0.8,0,0.8-0.8v-5.1H82.3",
    id: "SVGID_51_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_52_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_51_"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "st25",
    height: 17,
    width: 16.7,
    x: 76.2,
    y: 80.4
  }))), /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.1,92.4c-0.4,0-1.1,0-1.6,0c-0.6,0-1.2,0-1.6,0h0v-0.4h0.2c0.5,0,0.7,0,0.8-0.8l0-5.1h-1.5v-0.1H84v5.2    c0,0.8-0.3,0.8-0.8,0.8H83v0.2c0.4,0,1,0,1.6,0C85.1,92.3,85.7,92.4,86.1,92.4l0-0.3h-0.1c-0.5,0-0.8-0.1-0.8-0.9v-5.2h1.6    c0.6,0,0.7,0.6,0.7,0.9l0.2-0.1c0-0.3,0-0.5,0-0.8c0-0.2,0.1-0.5,0.1-0.7l-0.1,0c0,0.3-0.3,0.3-0.6,0.3h-5c-0.2,0-0.5,0-0.6-0.3    h-0.2c0,0.3,0,0.5-0.1,0.8c0,0.3-0.1,0.5-0.1,0.8h0.2c0.1-0.7,0.2-0.9,0.9-0.9v0.1c-0.7,0-0.7,0.1-0.9,0.8l0,0h-0.4l0,0    c0-0.3,0.1-0.5,0.1-0.8c0-0.3,0.1-0.5,0.1-0.8v0h0.3l0,0c0.1,0.2,0.2,0.2,0.5,0.2h5c0.3,0,0.5,0,0.5-0.3l0,0l0,0l0.3,0l0,0    c0,0.3-0.1,0.5-0.1,0.8c0,0.3,0,0.5,0,0.8v0l0,0l-0.3,0.1l0-0.1c0-0.4-0.1-0.9-0.7-0.9h-1.5v5.1c0,0.7,0.3,0.8,0.8,0.8h0.2    L86.1,92.4L86.1,92.4",
    id: "SVGID_53_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_54_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_53_"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "st26",
    height: 17.1,
    width: 16.8,
    x: 76.1,
    y: 80.4
  }))), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.2,92.1h0.1c0.3,0,0.7,0,0.7-0.5v-5c0-0.5-0.4-0.5-0.7-0.5h-0.1v-0.3c0.4,0,1,0,1.4,0    c0.5,0,1.1,0,1.5,0V86H91c-0.3,0-0.7,0-0.7,0.5v5c0,0.5,0.4,0.5,0.7,0.5h0.1v0.3c-0.5,0-1,0-1.5,0c-0.5,0-1,0-1.4,0V92.1",
    id: "SVGID_55_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_56_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_55_"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "st27",
    height: 16.7,
    width: 12.9,
    x: 83.2,
    y: 80.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.1,92.4v-0.2H91c-0.3,0-0.8-0.1-0.8-0.6v-5c0-0.5,0.4-0.6,0.8-0.6h0.1v-0.2c-0.4,0-1,0-1.5,0    c-0.5,0-1,0-1.4,0v0.2h0.1c0.3,0,0.8,0.1,0.8,0.6v5c0,0.5-0.4,0.6-0.8,0.6h-0.1v0.2c0.4,0,0.9,0,1.4,0    C90.1,92.3,90.6,92.4,91.1,92.4z M91.1,92.4c-0.5,0-1,0-1.5,0c-0.5,0-1,0-1.4,0h0v-0.4h0.2c0.3,0,0.7,0,0.7-0.5v-5    c0-0.5-0.3-0.5-0.7-0.5h-0.2v-0.4h0c0.4,0,1,0,1.4,0c0.5,0,1.1,0,1.5,0h0V86H91c-0.4,0-0.7,0-0.7,0.5v5c0,0.5,0.3,0.5,0.7,0.5h0.2    L91.1,92.4L91.1,92.4z",
    id: "SVGID_57_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_58_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_57_"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "st28",
    height: 16.8,
    width: 13,
    x: 83.2,
    y: 80.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.1,92.1c1.9,0,2.2-1.6,2.2-3c0-1.4-0.8-3.1-2.4-3.1c-1.7,0-2.2,1.5-2.2,2.8    C92.8,90.5,93.6,92.1,95.1,92.1 M95,85.6c2,0,3.7,1.3,3.7,3.3c0,2.2-1.6,3.7-3.6,3.7c-2,0-3.6-1.4-3.6-3.4    C91.4,87.1,93,85.6,95,85.6",
    id: "SVGID_59_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_60_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_59_"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "st29",
    height: 17,
    width: 17.2,
    x: 86.4,
    y: 80.6
  }))), /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M92.7,88.8c0-1.3,0.5-2.8,2.2-2.8c1.6,0,2.4,1.7,2.4,3.1c0,1.4-0.3,3.1-2.2,3.1v-0.1c1.8,0,2.1-1.6,2.1-3    c0-1.4-0.7-3.1-2.3-3.1C93.3,86,92.8,87.5,92.7,88.8c0.1,1.7,0.9,3.3,2.4,3.3v0.1C93.5,92.2,92.7,90.5,92.7,88.8 M91.4,89.1    c0-2,1.6-3.6,3.6-3.6v0.1C93,85.6,91.5,87.1,91.4,89.1c0.1,2,1.6,3.4,3.6,3.4c2,0,3.6-1.4,3.6-3.6c0-2-1.6-3.3-3.6-3.3v-0.1    c2.1,0,3.7,1.3,3.7,3.4c0,2.2-1.6,3.7-3.7,3.7C93,92.6,91.4,91.2,91.4,89.1",
    id: "SVGID_61_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_62_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_61_"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "st30",
    height: 17.1,
    width: 17.3,
    x: 86.4,
    y: 80.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.1,90.5L105.1,90.5l0-3.6c0-0.8-0.5-0.9-0.8-0.9h-0.2v-0.3c0.5,0,0.9,0,1.3,0c0.4,0,0.8,0,1.2,0V86    h-0.1c-0.4,0-0.9,0.1-0.9,1.2v4.4c0,0.3,0,0.7,0.1,1h-0.4l-4.9-5.5v4c0,0.8,0.2,1.1,0.9,1.1h0.2v0.3c-0.4,0-0.8,0-1.2,0    c-0.4,0-0.9,0-1.3,0v-0.3H99c0.7,0,0.9-0.5,0.9-1.2v-4c0-0.5-0.4-0.9-0.9-0.9h-0.1v-0.3c0.4,0,0.7,0,1.1,0c0.3,0,0.6,0,0.9,0    L105.1,90.5",
    id: "SVGID_63_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_64_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_63_"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "st31",
    height: 16.9,
    width: 17.7,
    x: 93.9,
    y: 80.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.1,90.5L105.1,90.5L105.1,90.5L105.1,90.5z M105.1,90.5L105.1,90.5L105.1,90.5z M105.3,92.5h0.3    c0-0.3-0.1-0.6-0.1-0.9v-4.4c0-1.2,0.5-1.3,0.9-1.3h0.1v-0.2c-0.4,0-0.8,0-1.1,0c-0.4,0-0.9,0-1.3,0v0.2h0.2    c0.3,0,0.9,0.1,0.9,0.9l0,3.6l0,0l0,0l-4.3-4.8c-0.3,0-0.6,0-0.9,0c-0.4,0-0.7,0-1.1,0v0.2H99c0.5,0,0.9,0.3,0.9,0.9v4    c0,0.8-0.2,1.3-0.9,1.3l-0.1,0v0.2c0.4,0,0.8,0,1.3,0c0.4,0,0.8,0,1.2,0v-0.2h-0.1c-0.8,0-0.9-0.3-0.9-1.2v-4.1L105.3,92.5z     M105.7,92.6l-0.4,0l-4.9-5.4V91c0,0.8,0.1,1.1,0.9,1.1h0.2v0.4h0c-0.4,0-0.8,0-1.2,0c-0.4,0-0.9,0-1.3,0h0v-0.4H99    c0.6,0,0.8-0.4,0.8-1.2v-4c0-0.5-0.4-0.8-0.8-0.8h-0.2v-0.4h0c0.4,0,0.7,0,1.1,0c0.3,0,0.6,0,0.9,0l4.2,4.8v-3.5    c0-0.8-0.5-0.9-0.8-0.9h-0.3v-0.4h0c0.5,0,0.9,0,1.3,0c0.4,0,0.8,0,1.2,0h0V86h-0.2c-0.4,0-0.8,0-0.8,1.2v4.4    C105.7,91.9,105.7,92.3,105.7,92.6L105.7,92.6L105.7,92.6z",
    id: "SVGID_65_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_66_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_65_"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "st32",
    height: 16.9,
    width: 17.8,
    x: 93.8,
    y: 80.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M109.6,86.8L109.6,86.8l-0.9,2.7h1.8L109.6,86.8z M108.2,91c-0.1,0.3-0.2,0.6-0.2,0.7    c0,0.3,0.4,0.3,0.7,0.3h0.1v0.3c-0.4,0-0.8,0-1.2,0c-0.3,0-0.7,0-1,0v-0.3h0.1c0.4,0,0.7-0.2,0.8-0.6l1.5-4.4    c0.1-0.4,0.3-0.8,0.4-1.2c0.3-0.1,0.7-0.3,0.9-0.4c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0.1,0.1,0.2,0.1,0.2l1.8,5    c0.1,0.3,0.2,0.7,0.4,1c0.1,0.3,0.3,0.4,0.6,0.4h0.1v0.3c-0.4,0-0.9,0-1.3,0c-0.5,0-1,0-1.4,0v-0.3h0.1c0.2,0,0.6,0,0.6-0.3    c0-0.1-0.1-0.4-0.2-0.7l-0.4-1.1h-2.2L108.2,91z",
    id: "SVGID_67_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_68_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_67_"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "st33",
    height: 16.9,
    width: 16.7,
    x: 101.6,
    y: 80.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M109.5,86.8L109.5,86.8L109.5,86.8z M108.7,89.5h1.7l-0.8-2.6L108.7,89.5z M108.6,89.5l0.9-2.8h0v0l0,0    l0,0v0h0l0.9,2.8H108.6z M110.6,92.4c0.5,0,0.9,0,1.4,0c0.4,0,0.9,0,1.3,0l0-0.2h0c-0.3,0-0.6-0.1-0.7-0.4c-0.1-0.3-0.2-0.6-0.4-1    l-1.8-5c0-0.1-0.1-0.2-0.1-0.2c0,0,0,0,0,0h0c0,0,0,0-0.1,0c-0.2,0.1-0.6,0.3-0.9,0.4c-0.1,0.4-0.2,0.8-0.4,1.2l-1.5,4.4    c-0.1,0.4-0.5,0.7-0.9,0.7h0v0.2c0.3,0,0.7,0,1,0c0.4,0,0.8,0,1.1,0v-0.2h-0.1c-0.3,0-0.8,0-0.8-0.4c0-0.2,0.1-0.4,0.2-0.8l0,0    l0,0l0.3-1h2.2l0.4,1.1c0.1,0.3,0.2,0.6,0.2,0.7c0,0.3-0.4,0.3-0.6,0.3h-0.1V92.4z M113.3,92.4c-0.4,0-0.9,0-1.3,0    c-0.5,0-1,0-1.4,0l0,0v-0.4h0.1c0.2,0,0.6-0.1,0.6-0.2c0-0.1-0.1-0.4-0.2-0.7l-0.4-1.1h-2.1l-0.3,1c-0.1,0.3-0.2,0.6-0.2,0.7    c0,0.2,0.4,0.3,0.7,0.3h0.1v0.4l0,0c-0.4,0-0.8,0-1.2,0c-0.3,0-0.7,0-1,0l0,0v-0.4h0.1c0.4,0,0.7-0.2,0.8-0.6l1.5-4.4    c0.1-0.4,0.3-0.8,0.4-1.2c0.3-0.1,0.7-0.3,0.9-0.4c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0.1,0.1,0.2,0.1,0.2l1.8,5    c0.1,0.3,0.2,0.7,0.4,1c0.1,0.3,0.3,0.4,0.6,0.4h0.1L113.3,92.4L113.3,92.4z",
    id: "SVGID_69_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_70_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_69_"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "st34",
    height: 17,
    width: 16.8,
    x: 101.5,
    y: 80.4
  }))), /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M115.7,91.5c0,0.4,0.3,0.5,0.6,0.5c0.4,0,0.8,0,1.3,0c0.4,0,0.7-0.3,0.9-0.5c0.2-0.2,0.2-0.5,0.3-0.7h0.3    c-0.1,0.5-0.2,1.1-0.4,1.6c-0.8,0-1.7,0-2.5,0c-0.8,0-1.7,0-2.5,0v-0.3h0.1c0.3,0,0.7,0,0.7-0.6v-4.9c0-0.5-0.4-0.5-0.7-0.5h-0.1    v-0.3c0.5,0,1,0,1.5,0c0.5,0,1,0,1.5,0V86h-0.2c-0.4,0-0.7,0-0.7,0.5V91.5",
    id: "SVGID_71_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_72_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_71_"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "st35",
    height: 16.7,
    width: 15.4,
    x: 108.6,
    y: 80.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M118.7,92.4c0.1-0.5,0.2-1,0.3-1.6h-0.2c-0.1,0.2-0.1,0.5-0.3,0.7c-0.2,0.2-0.5,0.5-1,0.5    c-0.3,0-0.5,0-0.7,0c-0.2,0-0.4,0-0.5,0c-0.3,0-0.6-0.2-0.6-0.6v-5c0-0.5,0.3-0.6,0.7-0.6h0.2v-0.2c-0.5,0-0.9,0-1.4,0    c-0.5,0-1,0-1.5,0v0.2h0.1c0.3,0,0.8,0.1,0.8,0.6v4.9c0,0.6-0.4,0.7-0.8,0.7h-0.1v0.2c0.8,0,1.7,0,2.5,0    C117,92.3,117.8,92.4,118.7,92.4z M118.7,92.4c-0.8,0-1.7,0-2.5,0c-0.8,0-1.7,0-2.5,0h0v-0.4h0.2c0.3,0,0.7,0,0.7-0.6v-4.9    c0-0.5-0.3-0.5-0.7-0.5h-0.2v-0.4h0c0.5,0,1,0,1.5,0c0.5,0,1,0,1.5,0h0V86h-0.3c-0.4,0-0.6,0-0.6,0.5v5c0,0.4,0.2,0.5,0.5,0.5    c0.2,0,0.3,0,0.5,0c0.2,0,0.5,0,0.7,0c0.4,0,0.7-0.3,0.9-0.5c0.1-0.2,0.2-0.5,0.3-0.7l0,0h0.4l0,0.1    C119,91.3,118.8,91.9,118.7,92.4L118.7,92.4L118.7,92.4z",
    id: "SVGID_73_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_74_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_73_"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "st36",
    height: 16.8,
    width: 15.5,
    x: 108.6,
    y: 80.7
  }))), /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M118.8,86.4h0.1c0.1,0,0.2-0.1,0.2-0.3c0-0.2-0.1-0.2-0.2-0.2h-0.1V86.4z M118.4,87L118.4,87    c0.1-0.1,0.1-0.1,0.1-0.1v-0.7c0-0.1,0-0.1-0.1-0.1v-0.1h0.5c0.2,0,0.3,0.1,0.3,0.3c0,0.2-0.1,0.3-0.2,0.3l0.2,0.2    c0.1,0.1,0.2,0.2,0.2,0.2v0h-0.2c-0.1,0-0.2-0.2-0.4-0.5h-0.1v0.3c0,0.1,0,0.1,0.1,0.1v0H118.4z M118.9,87.3    c0.5,0,0.8-0.4,0.8-0.8c0-0.4-0.3-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C118.1,86.9,118.5,87.3,118.9,87.3z M118.9,85.4    c0.6,0,1,0.4,1,1c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1C117.9,85.9,118.4,85.4,118.9,85.4z",
    id: "SVGID_75_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_76_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_75_"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "st37",
    height: 12,
    width: 12,
    x: 112.9,
    y: 80.4
  }))), /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.9,51.8c0-9,7.3-16.3,16.3-16.3c9,0,16.3,7.3,16.3,16.3c0,9-7.3,16.3-16.3,16.3    C66.2,68.1,58.9,60.8,58.9,51.8",
    id: "SVGID_77_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_78_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_77_"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "st38",
    height: 42.5,
    width: 42.5,
    x: 53.9,
    y: 30.5
  }))), /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.2,68.3c-9.3,0-17-7.5-17-16.7c0-10,7.7-17,17-17h4.4c9.2,0,17.6,6.9,17.6,17c0,9.2-8.4,16.7-17.6,16.7    H75.2z M75.3,36c-8.5,0-15.4,6.9-15.4,15.4c0,8.5,6.9,15.4,15.4,15.4c8.5,0,15.4-6.9,15.4-15.4C90.7,42.9,83.8,36,75.3,36z     M71.8,60.6V42.3c-3.7,1.4-6.3,5-6.3,9.1C65.5,55.6,68.1,59.2,71.8,60.6z M85,51.5c0-4.2-2.6-7.7-6.3-9.1v18.3    C82.4,59.2,85,55.6,85,51.5z",
    id: "SVGID_79_"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_80_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_79_"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "st39",
    height: 43.7,
    width: 49,
    x: 53.2,
    y: 29.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinerClub);
export default __webpack_public_path__ + "static/media/DinerClub.daaaca0c2b9d8f88156d9d829ff33de8.svg";
export { ForwardRef as ReactComponent };